import { render, staticRenderFns } from "./DiffModal.vue?vue&type=template&id=2808cee6&"
import script from "./DiffModal.vue?vue&type=script&lang=js&"
export * from "./DiffModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports